import { Injectable, ViewContainerRef, ComponentFactoryResolver, Inject } from '@angular/core';
import { AchooModalDialogInstanceService } from '../../core/achoo-modal-dialog/achoo-modal-dialog-instance.service';
import { IModalDialogOptions } from '../../core/achoo-modal-dialog/achoo-modal-dialog.interface';
import { AchooModalDialogComponent } from '../../core/achoo-modal-dialog/achoo-modal-dialog.component';

@Injectable()
export class ModalDialogService {
  /**
   * CTOR
   * @param componentFactoryResolver
   * @param modalDialogInstanceService
   */
  constructor(
    @Inject(ComponentFactoryResolver) private componentFactoryResolver: ComponentFactoryResolver,
    @Inject(AchooModalDialogInstanceService) private modalDialogInstanceService: AchooModalDialogInstanceService
  ) { }

  /**
   * Open dialog in given target element with given options
   * @param  {ViewContainerRef} target
   * @param  {IModalDialogOptions} options?
   */
  openDialog(target: ViewContainerRef, options: Partial<IModalDialogOptions<any>> = {}) {
    this.modalDialogInstanceService.closeAnyExistingModalDialog();

    const factory = this.componentFactoryResolver.resolveComponentFactory(AchooModalDialogComponent);
    const componentRef = target.createComponent(factory);
    componentRef.instance.dialogInit(componentRef, options);

    this.modalDialogInstanceService.saveExistingModalDialog(componentRef);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/modal-dialog/achoo-modal-dialog.service.ts